import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './Historial.css';

const REGISTROS_POR_PAGINA = 20;

const Historial = () => {
  const [registros, setRegistros]   = useState([]);
  const [busqueda, setBusqueda]     = useState('');
  const [error, setError]           = useState(null);
  const [cargando, setCargando]     = useState(false);
  const [pagina, setPagina]         = useState(1);
  const [tooltip, setTooltip]       = useState({ visible:false, x:0, y:0, text:'' });

  const obtenerHistorial = useCallback(async () => {
    try {
      if (registros.length === 0) setCargando(true);
      const response = await api.get(`/api/historial/?search=${busqueda}&t=${Date.now()}`);
      setRegistros(response.data);
      setError(null);
    } catch (err) {
      if (err.response?.status === 403) setError("⛔ ACCESO DENEGADO");
    } finally {
      setCargando(false);
    }
  }, [busqueda, registros.length]);

  useEffect(() => {
    const t = setTimeout(obtenerHistorial, 500);
    const i = setInterval(obtenerHistorial, 5000);
    return () => { clearTimeout(t); clearInterval(i); };
  }, [obtenerHistorial]);

  // Cuando cambia la búsqueda, volvemos a la primera página
  useEffect(() => { setPagina(1); }, [busqueda]);

  // ── Paginación ──
  const totalRegistros  = registros.length;
  const totalPaginas    = Math.ceil(totalRegistros / REGISTROS_POR_PAGINA);
  const inicio          = (pagina - 1) * REGISTROS_POR_PAGINA;
  const registrosPagina = registros.slice(inicio, inicio + REGISTROS_POR_PAGINA);

  return (
    <div className="historial-wrapper">

      {/* Tooltip flotante (desktop) */}
      {tooltip.visible && (
        <div style={{
          position:'fixed', top:tooltip.y+15, left:tooltip.x+15, zIndex:9999,
          background:'rgba(0,45,92,0.95)', color:'white', padding:'10px 15px',
          borderRadius:'6px', boxShadow:'0 4px 15px rgba(0,0,0,0.3)',
          fontSize:'12px', pointerEvents:'none', whiteSpace:'nowrap'
        }}>
          <div style={{ color:'#FFB500', fontWeight:'bold', marginBottom:3, textTransform:'uppercase' }}>LIBERACIÓN MANUAL</div>
          <div>Responsable: <strong>{tooltip.text}</strong></div>
        </div>
      )}

      {/* Barra de búsqueda */}
      <div className="barra-busqueda">
        <input
          type="text"
          placeholder="Buscar por nombre, patente o cargo..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
        />
        <button onClick={obtenerHistorial}>BUSCAR</button>
      </div>

      {error && (
        <div style={{ padding:'12px', background:'#ffebee', color:'#c62828', borderRadius:'6px', flexShrink:0 }}>
          {error}
        </div>
      )}

      {/* Tabla con scroll interno */}
      <div className="tabla-contenedor">
        <div className="tabla-scroll-inner">
          <table className="tabla-historial">
            <thead>
              <tr>
                <th>USUARIO</th>
                <th className="col-rut"     style={{ padding:'13px 14px' }}>RUT</th>
                <th className="col-cargo"   style={{ padding:'13px 14px' }}>CARGO</th>
                <th>PATENTE</th>
                <th className="col-destino" style={{ padding:'13px 14px' }}>DESTINO</th>
                <th style={{ textAlign:'center' }}>LUGAR</th>
                <th>HORARIO</th>
                <th style={{ textAlign:'center' }}>ESTADO</th>
              </tr>
            </thead>
            <tbody>
              {cargando && registros.length === 0 && (
                <tr><td colSpan="8" style={{ padding:20, textAlign:'center', color:'#999' }}>Cargando...</td></tr>
              )}
              {!cargando && registros.length === 0 && (
                <tr><td colSpan="8" style={{ padding:20, textAlign:'center', color:'#666' }}>No se encontraron registros.</td></tr>
              )}
              {registrosPagina.map((r, index) => (
                <tr key={r.id} style={{ background: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                  <td><strong>{r.nombre}</strong></td>
                  <td className="col-rut"     style={{ fontSize:11, color:'#666' }}>{r.rut}</td>
                  <td className="col-cargo">{r.cargo}</td>
                  <td style={{ fontWeight:'bold', color:'#002D5C' }}>{r.patente || '---'}</td>
                  <td className="col-destino">{r.destino || '---'}</td>
                  <td style={{ textAlign:'center' }}>
                    <span style={{ background:'#e3f2fd', color:'#0d47a1', padding:'4px 9px', borderRadius:4, fontWeight:'bold' }}>
                      {r.lugar}
                    </span>
                  </td>
                  <td>
                    {r.estado === 'Activo' ? (
                      <span style={{ color:'#aaa', fontStyle:'italic' }}>En curso</span>
                    ) : (
                      <div>
                        <div style={{ fontSize:12 }}>{r.ingreso}</div>
                        <div style={{ fontSize:12 }}>{r.salida}</div>
                        <div style={{ marginTop:4 }}>
                          {r.tipo_salida === 'MANUAL' ? (
                            <span
                              style={{ background:'#ffebee', color:'#c62828', border:'1px solid #ffcdd2', padding:'2px 7px', borderRadius:12, fontSize:10, fontWeight:'bold', cursor:'help', display:'inline-flex', alignItems:'center', gap:3 }}
                              onMouseEnter={e => setTooltip({ visible:true, x:e.clientX, y:e.clientY, text:r.liberado_por||'Admin' })}
                              onMouseMove={e  => setTooltip(p => ({ ...p, x:e.clientX, y:e.clientY }))}
                              onMouseLeave={()=> setTooltip({ visible:false, x:0, y:0, text:'' })}
                            >⚠️ MANUAL</span>
                          ) : r.tipo_salida === 'AUTOMATICA' ? (
                            <span style={{ background:'#e8eaf6', color:'#283593', border:'1px solid #c5cae9', padding:'2px 7px', borderRadius:12, fontSize:10, fontWeight:'bold', display:'inline-flex', alignItems:'center', gap:3 }}
                              title="Liberado por limpieza nocturna">
                              🌙 AUTOMÁTICO
                            </span>
                          ) : (
                            <span style={{ color:'#aaa', fontSize:12, fontStyle:'italic' }}>📱 Escáner</span>
                          )}
                        </div>
                      </div>
                    )}
                  </td>
                  <td style={{ textAlign:'center' }}>
                    <span style={{ padding:'5px 10px', borderRadius:20, fontSize:11, fontWeight:'bold', background: r.estado==='Activo'?'#d4edda':'#f8d7da', color: r.estado==='Activo'?'#155724':'#721c24' }}>
                      {r.estado === 'Activo' ? 'EN SITIO' : 'FINALIZADO'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer con contador y paginación */}
        <div className="tabla-footer" style={{ padding: '15px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
          <span style={{ fontSize: '13px', color: '#555' }}>
            Mostrando <strong>{inicio + 1}–{Math.min(inicio + REGISTROS_POR_PAGINA, totalRegistros)}</strong> de <strong>{totalRegistros}</strong> registros
          </span>
          
          {totalPaginas > 1 && (
            <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
              {/* Botón Atrás */}
              <button
                onClick={() => setPagina(p => Math.max(1, p-1))}
                disabled={pagina === 1}
                style={{ 
                  minWidth:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', 
                  border:'1px solid #ccc', borderRadius:'6px', background: pagina===1?'#f5f5f5':'white', 
                  cursor: pagina===1?'not-allowed':'pointer', fontWeight:'bold', color: pagina===1?'#aaa':'#002D5C', fontSize:'18px',
                  transition: 'all 0.2s'
                }}
              >‹</button>
              
              {/* Botones de Números */}
              {Array.from({ length: totalPaginas }, (_, i) => i+1).map(n => (
                <button key={n} onClick={() => setPagina(n)}
                  style={{ 
                    minWidth:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', 
                    border:'1px solid', borderColor: n===pagina?'#002D5C':'#ccc', borderRadius:'6px', 
                    background: n===pagina?'#002D5C':'white', color: n===pagina?'white':'#333', 
                    cursor:'pointer', fontWeight: n===pagina?'bold':'normal', fontSize:'13px',
                    transition: 'all 0.2s'
                  }}
                >{n}</button>
              ))}

              {/* Botón Adelante */}
              <button
                onClick={() => setPagina(p => Math.min(totalPaginas, p+1))}
                disabled={pagina === totalPaginas}
                style={{ 
                  minWidth:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', 
                  border:'1px solid #ccc', borderRadius:'6px', background: pagina===totalPaginas?'#f5f5f5':'white', 
                  cursor: pagina===totalPaginas?'not-allowed':'pointer', fontWeight:'bold', color: pagina===totalPaginas?'#aaa':'#002D5C', fontSize:'18px',
                  transition: 'all 0.2s'
                }}
              >›</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Historial;